<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="privacy-protection">
      <Title jpn="Politica sulla riservatezza" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Xero Place Co., Ltd. (di seguito denominata "la Società") richiede agli utenti di fornire una quantità minima di informazioni personali in modo che possano utilizzare il sito in tutta tranquillità.</span>
            <span class="text">Inoltre, prestiamo la massima attenzione a proteggere le informazioni personali che ci vengono fornite.</span>
            <span class="text">L'approccio della nostra azienda alla protezione delle informazioni personali è il seguente.</span>
            <br>
            <span class="text">(1) La Società utilizzerà le informazioni di individui, organizzazioni e società registrate dai membri solo per sviluppare e fornire funzioni e servizi all'avanguardia e presterà molta attenzione alla protezione delle informazioni personali dei membri.</span>
            <span class="text">(2) La presente informativa sulla privacy si applica solo ai servizi forniti dalla nostra azienda.</span>
            <span class="text">(3) Ad eccezione di quanto specificato nei presenti Termini, le informazioni non verranno utilizzate per nessun altro scopo.</span>
            <span class="text">(4) Ad eccezione di quanto specificato nei presenti Termini, non divulgheremo le tue informazioni a terzi.</span>
            <span class="text">(5) Condurremo regolarmente una gestione adeguata utilizzando altri metodi stabiliti nei presenti Termini.</span>
            <span class="text">(6) La nostra azienda può modificare la politica sulla privacy senza il consenso dell'utente.</span>
            <span class="text">Quando la nostra azienda apporta modifiche al contenuto delle informazioni personali acquisite, alle modalità di utilizzo, alle modifiche al contenuto dell'informativa, ecc., ti avviseremo pubblicando un avviso sul nostro sito Web e riflettendolo nella presente informativa sulla privacy in modo che gli utenti possano essere consapevoli del contenuto.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Sezione 1. Ambito di applicazione della nostra politica sulla privacy</span>
            <span class="text">(1) La nostra politica sulla privacy si applica quando i membri utilizzano i nostri servizi.</span>
            <span class="text">(2) Le informazioni personali raccolte quando i membri utilizzano i nostri servizi saranno gestite in conformità con la politica della nostra azienda sulla protezione delle informazioni personali.</span>
            <span class="text">(3) La nostra politica sulla protezione dei dati personali si applica solo ai servizi forniti direttamente dalla nostra azienda e non si applica ai servizi forniti da altre organizzazioni o società.</span>
            <span class="text">(4) L'utilizzo dei nostri servizi è a rischio e pericolo dell'utente.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Sezione 2. Raccolta e utilizzo delle nostre informazioni personali</span>
            <span class="text">(1) Al fine di sviluppare e fornire funzioni e servizi all'avanguardia ai nostri membri, richiediamo alcune informazioni personali dai nostri utenti.</span>
            <span class="text">(2) Gli utenti sono responsabili della gestione del proprio indirizzo e-mail e della password registrati.</span>
            <span class="text">1. Cambia regolarmente la tua password e ti consigliamo di non utilizzare nomi, date di nascita, numeri di telefono, ecc. facili da indovinare per gli altri.</span>
            <span class="text">2. Ti preghiamo di non divulgare, prestare o trasferire le tue informazioni personali, anche se si tratta di un conoscente o un amico.</span>
            <span class="text">(3) Le informazioni personali raccolte verranno utilizzate solo nella misura necessaria per fornire i nostri servizi e non saranno fornite a terzi tranne nei seguenti casi.</span>
            <span class="text">1. Quando la società emittente della carta di credito effettua una richiesta per indagare sull'utilizzo fraudolento della carta.</span>
            <span class="text">2. Quando si inviano e-mail ecc. per fare pubblicità ai membri.</span>
            <span class="text">3. Quando si affida il trattamento dei dati personali a un subappaltatore con il quale abbiamo concluso un accordo di riservatezza sui dati personali nella misura necessaria per raggiungere lo scopo di utilizzo specificato all'utente.</span>
            <span class="text">4. Quando si ritiene necessario proteggere i diritti o la proprietà di altri membri, di terzi o della Società, nel caso in cui le azioni di un membro presso la Società violino le politiche, gli annunci o i Termini di utilizzo della Società.</span>
            <span class="text">5. Quando la divulgazione di dati personali è richiesta in conformità con le disposizioni di altre leggi come ordini di un tribunale o di un ente amministrativo, o quando è necessaria un'indagine penale, l'eliminazione o la prevenzione della violazione di diritti contro terzi, o altra necessità simile.</span>
            <span class="text">(4) I membri acconsentono in anticipo all'utilizzo dei dati personali da parte della Società nelle modalità sopra specificate e non sollevano alcuna obiezione.</span>
            <span class="text">(5) Inoltre, potremmo condividere le informazioni personali dei membri con i nostri partner commerciali nei seguenti casi:</span>
            <span class="text">1. Quando c'è una ragione commerciale, come servizi speciali per i membri. In questo caso, chiederemo il consenso del membro prima di fornire le informazioni e non forniremo le informazioni senza il suo consenso.</span>
            <span class="text">2. Durante la creazione di materiale statistico, lo svolgimento di ricerche di mercato o l'analisi dei dati. In questo caso, forniremo solo informazioni che sono state elaborate in modo che non sia possibile identificare individui specifici.</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.privacy-protection{
  width: 100%;
  max-width: 1200px;
  min-height: 100%;
  padding: 30px 20px 0;
  margin: 0 auto;
  .privacy-protection-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: $white!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.indent{
            padding-left: 2.6em;
            text-indent: -1.6em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
